import ShingleColor from './ShingleColor';

const ShingleColorsList = ({ houseView, onColorClick, selectedColor, shingle, address, isPDP }) =>
  shingle.shingle_colors.map(color => (
    <ShingleColor
      key={color.uuid}
      shingle={shingle}
      color={color}
      houseView={houseView}
      onClick={onColorClick}
      isSelected={selectedColor && color.uuid === selectedColor.uuid}
      address={address}
      isPDP={isPDP}
    />
  ));
export default ShingleColorsList;
